/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-04-04 10:00:14
 *
 *******************************************************/
// @flow

import type { MigrateNewFlowState, MigrateNewFlowAction } from 'stores/flow-type/common.type';
import _ from 'lodash';

import {
  GET_STATUS_MIGRATE_DATA_NEW_SEARCH_REQUEST,
  GET_STATUS_MIGRATE_DATA_NEW_SEARCH_SUCCESS,
  GET_STATUS_MIGRATE_DATA_NEW_SEARCH_FAILURE,
  MIGRATE_DATA_TO_NEW_SEARCH_V2_REQUEST,
  MIGRATE_DATA_TO_NEW_SEARCH_V2_SUCCESS,
  MIGRATE_DATA_TO_NEW_SEARCH_V2_FAILURE,
  SEND_SURVEY_FEEDBACK_REQUEST,
  SEND_SURVEY_FEEDBACK_SUCCESS,
  SEND_SURVEY_FEEDBACK_FAILURE,
  RESET_SURVEY_FEEDBACK,
  SEND_FEEDBACK_AFTER_RATING_5STARS_REQUEST,
  SEND_FEEDBACK_AFTER_RATING_5STARS_SUCCESS,
  SEND_FEEDBACK_AFTER_RATING_5STARS_FAILURE,
} from 'stores/flow-type/common.type';

const initialState: MigrateNewFlowState = {
  loading: false,
  success: false,
  error: undefined,
  migrating: false,
  migrateSuccess: false,
  sending: false,
  sendSuccess: false,
  feedback: {},
  onboarding: {},
  status: null,
  feedback5StarsLoading: false,
  feedback5Stars: {},
  feedback5StarsSendSuccess: false
};

const CommonReducers = (
  state: MigrateNewFlowState = initialState,
  action: MigrateNewFlowAction
) => {
  switch (action.type) {
    case GET_STATUS_MIGRATE_DATA_NEW_SEARCH_REQUEST:
      return { ...state, loading: true };
    case GET_STATUS_MIGRATE_DATA_NEW_SEARCH_SUCCESS: {
      const { data } = action.payload;
      let status = _.get(data, 'status', null);
      if (!['undetermined', 'running', 'done'].includes(status)) {
        status = 'running';
      }
      return { ...state, loading: false, success: true, status };
    }
    case GET_STATUS_MIGRATE_DATA_NEW_SEARCH_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };
    case MIGRATE_DATA_TO_NEW_SEARCH_V2_REQUEST:
      return { ...state, migrating: true };
    case MIGRATE_DATA_TO_NEW_SEARCH_V2_SUCCESS: {
      const { data } = action.payload;
      return { ...state, migrating: false, success: true, data };
    }
    case MIGRATE_DATA_TO_NEW_SEARCH_V2_FAILURE:
      return {
        ...state,
        migrating: false,
        success: false,
        error: action.payload
      };
    case SEND_SURVEY_FEEDBACK_REQUEST:
      return { ...state, sending: true };
    case SEND_SURVEY_FEEDBACK_SUCCESS: {
      const { data } = action.payload;
      return { ...state, sending: false, sendSuccess: true, feedback: data };
    }
    case SEND_SURVEY_FEEDBACK_FAILURE:
      return {
        ...state,
        sending: false,
        sendSuccess: false,
        error: action.payload
      };
    case SEND_FEEDBACK_AFTER_RATING_5STARS_REQUEST:
      return { ...state, feedback5StarsLoading: true };
    case SEND_FEEDBACK_AFTER_RATING_5STARS_SUCCESS: {
      const { data, isSubmit } = action.payload;
      return {
        ...state,
        feedback5StarsLoading: false,
        feedback5StarsSendSuccess: true,
        feedback5Stars: data,
        feedback5StarsIsSubmit: isSubmit
      };
    }
    case SEND_FEEDBACK_AFTER_RATING_5STARS_FAILURE:
      return {
        ...state,
        feedback5StarsLoading: false,
        feedback5StarsSendSuccess: false,
        error: action.payload
      };
    case RESET_SURVEY_FEEDBACK:
      return {
        ...state,
        sending: false,
        sendSuccess: false,
        error: null
      };
    default:
      return state;
  }
};

export default CommonReducers;
